import { ResourcesTab } from '../../components/organisms/navigation/ResourcesTab'
import useUserPermission from '../useUserPermission'

const useOfficeHoursRoute = () => {
  const { canSeeOfficeHours } = useUserPermission('menu')

  return [{ path: '/horarios-de-atencion', component: ResourcesTab, hasPermission: canSeeOfficeHours }]
}
export default useOfficeHoursRoute
